"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var GovernanceIcon_1 = __importDefault(require("../../../Icons/Notifications/GovernanceIcon"));
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
var GovernanceAnnouncementNotification = function (_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: { image: react_1.default.createElement(GovernanceIcon_1.default, { width: "48", height: "48" }) }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, notification.metadata.title),
        react_1.default.createElement("a", { href: notification.metadata.link },
            react_1.default.createElement("p", { className: "dcl notification-item__content-description" },
                notification.metadata.description,
                ' '))));
};
exports.default = GovernanceAnnouncementNotification;
